import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/chart-bar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M396.8 352c-6.4 0-12.8-6.4-12.8-12.8v-230.4c0-6.4 6.4-12.8 12.8-12.8h22.4c6.4 0 12.8 6.4 12.8 12.8v230.4c0 6.4-6.4 12.8-12.8 12.8h-22.4zM204.8 352c-6.4 0-12.8-6.4-12.8-12.8v-198.4c0-6.4 6.4-12.8 12.8-12.8h22.4c6.4 0 12.8 6.4 12.8 12.8v198.4c0 6.4-6.4 12.8-12.8 12.8h-22.4zM300.8 352c-6.4 0-12.8-6.4-12.8-12.8v-134.4c0-6.4 6.4-12.8 12.8-12.8h22.4c6.4 0 12.8 6.4 12.8 12.8v134.4c0 6.4-6.4 12.8-12.8 12.8h-22.4zM496 400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-464c-17.7 0-32-14.3-32-32v-336c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v320h448zM108.8 352c-6.4 0-12.8-6.4-12.8-12.8v-70.4c0-6.4 6.4-12.8 12.8-12.8h22.4c6.4 0 12.8 6.4 12.8 12.8v70.4c0 6.4-6.4 12.8-12.8 12.8h-22.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/chart-bar.js
// module id = 1705
// module chunks = 0